module.exports = __webpack_public_path__ + "img/banner_index.77cdbc44.png";